<template>
  <ul class="footer">
    <li v-for="(item,index) in list" :key="index" :class="$route.name===item.name?'active':''" @click="goto(item.path)">
      <i class="iconfont" :class="item.icon"></i>
      <h6 class="title">{{item.name}}</h6>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "homePage",
    data() {
      return {
        num: true,
        currentMenu: '首页',
        list: [
          {
            img: require("../../../../static/img/house.png"),  //原始显示的图标
            active: require("../../../../static/img/bluehome.png"), //点击之后要显示的图标
            icon: 'iconfont-shouye',
            name: "首页",
            path: "/home",
          },
          // {
          //   img: require("../../static/img/function.png"),
          //   active: require("../../static/img/bluefunction.png"),
          //   icon: 'iconfont-duozhonggongneng',
          //   name: "功能",
          //   path: "/fun",
          //   title: "title"
          // },
          {
            img: require("../../../../static/img/sc.png"),
            active: require("../../../../static/img/sc.png"),
            icon: 'iconfont-saoyisao-tianchong',
            name: "文档中心",
            path: "/document",
          },
          // {
          //   img: require("../../static/img/talk.png"),
          //   active: require("../../static/img/bluetalk.png"),
          //   icon: 'iconfont-kefu',
          //   name: "联系客服",
          //   path: "/cus",
          //   title: "cus"
          // },
          {
            img: require("../../../../static/img/my.png"),
            active: require("../../../../static/img/bluemy.png"),
            icon: 'iconfont-wode2',
            name: "我的",
            path: "/mine",
          }
        ],
      }
    },
    methods: {
      goto(path) {
        this.$router.replace(path);
      },
    }
  }
</script>

<style lang="less" scoped>
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: row;

    li {
      flex: 1;
      text-align: center;
      padding: 1rem 0;

      &:nth-child(2) {
        margin-top: -2rem;

        .iconfont {
          font-size: 4rem;
          color: #379CE2;
          border: solid 4px white;
          border-radius: 50%;
        }

        .title {

        }
      }

      .iconfont {
        font-size: 2.5rem;
      }

      .title {
        margin-top: .5rem;
      }

      &.active {
        .iconfont, .title {
          color: #1fb1c4
        }
      }
    }
  }

  /*.footer .title {*/
  /*  display: block;*/
  /*  display: flex;*/
  /*  flex-direction: column;*/
  /*  justify-content: space-around;*/
  /*  align-items: center;*/
  /*  height: 0.45rem;*/
  /*}*/

  /*.footer .title p {*/
  /*  font-size: 0.09rem;*/
  /*  color: black;*/
  /*}*/

  /*.footer .title img {*/
  /*  width: 0.2rem;*/
  /*  height: 0.2rem;*/
  /*}*/

  /*.footer .cus p {*/
  /*  font-size: 0.09rem;*/
  /*  margin-top: 0.04rem;*/
  /*  color: black;*/
  /*}*/

  /*.footer .cus img {*/
  /*  width: 0.2rem;*/
  /*  height: 0.2rem;*/
  /*  margin-left: 0.1rem;*/
  /*}*/

  /*.footer .rels {*/
  /*  display: flex;*/
  /*}*/

  /*.footer .rels {*/
  /*  position: relative;*/
  /*}*/

  /*.footer .rels p {*/
  /*  margin-top: 0.23rem;*/
  /*  color: #6d6d6d;*/
  /*  margin-left: 6px;*/
  /*}*/

  /*.footer .rels img {*/
  /*  width: 0.38rem;*/
  /*  height: 0.38rem;*/
  /*  position: absolute;*/
  /*  top: -0.15rem;*/
  /*  left: 0.07rem*/
  /*}*/
</style>

